<template>
  <form :action="buildCompanyRoute('login')" method="POST" class="space-y-6">

<!--    Add a paragraph with poppins bold font; 18 point; color 002250-->
    <p v-if="showAdditionalLoginText" class="text-lg font-bold" style="color: #002250;">
      Login to continue
    </p>

  <div>
    <label for="login" class="sr-only">
      Email
    </label>
    <div class="rounded-md shadow-sm">
      <input type="text" id="login"
             name="login"
             placeholder="Email"
             required
             v-model="email"
             class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue-200 focus:border-blue-300 text-lg sm:text-base sm:leading-5">
    </div>
  </div>

    <transition
        enter-active-class="transition-all ease-in-out duration-700"
        enter-class="opacity-0 scale-70"
        enter-to-class="opacity-100 scale-100">
  <div v-if="showPassword">
    <label for="password" class="sr-only">
      Password
    </label>
    <div class="rounded-md shadow-sm">
      <input id="password"
             name="password"
             type="password"
             ref="password"
             placeholder="Password" required
             class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue-200 focus:border-blue-300 text-lg sm:text-base sm:leading-5">
    </div>
  </div>
    </transition>

  <div v-if="!showPassword">
    <span class="block w-full rounded-md shadow-sm">
      <button
          @submit.prevent
          @click="checkForSingleSignOn"
          :disabled="email === ''"
          :class="[email !== '' ? 'hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:ring-blue-200 active:bg-blue-700 transition duration-150 ease-in-out' : '']"
          class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 ">
        <template v-if="isProcessing">
          <span class="lnr icon-loading animate-spin" style="font-size: 1.2rem;"></span>
          <span class="pl-4">Processing</span>
        </template>
        <template v-else-if="isRedirecting">
          <span class="lnr icon-loading animate-spin" style="font-size: 1.2rem;"></span>
          <span class="pl-4">Redirecting to SSO...</span>
        </template>
        <template v-else-if="email ===''"> Please Enter Your Email </template>
        <template v-else>Continue</template>
      </button>
    </span>
  </div>
  <div v-if="showPassword">
    <span class="block w-full rounded-md shadow-sm">
      <button type="submit"
              @click="isRedirecting = true"
              class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:ring-blue-200 active:bg-blue-700">
        <template v-if="isRedirecting">
          <span class="lnr icon-loading animate-spin" style="font-size: 1.2rem;"></span>
          <span class="pl-4">Logging you in...</span>
        </template>
        <template v-else>
          Log In!
        </template>
      </button>
    </span>
  </div>
  </form>
</template>

<script>
import axios from 'axios';
export default {
  mixins: [],
  name: "login",
  props: {
    showAdditionalLoginText: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      showPassword: false,
      isProcessing: false,
      isRedirecting: false,
      email: '',
    }
  },
  methods: {
    checkForSingleSignOn(e){
      e.preventDefault();
      if (this.email === '') {
        return
      }
      this.isProcessing = true;

      axios.post('/api-internal/login', {email: this.email})
          .then((response) => {
            var data = response.data;
            if(data.data !== undefined){
              data = data.data;
              if(data['should_redirect'] !== undefined && data['should_redirect'] === true){
                this.isRedirecting = true;
                window.location.href = data['redirect_target']
              } else {
                this.showPassword = true;
                this.$nextTick(() => {
                  this.$refs.password.focus();
                });
              }
            }
            this.isProcessing = false;
          });
    },
    buildCompanyRoute(inputRoute) {
      // We keep this function in here to ensure we're not using the SonicuCoreMixin which
      // can have issues due to redirects when requesting permissions/features
      return "/" + this.getCompanyId() + "/" + inputRoute;
    },
    getCompanyId() {
      let path = window.location.pathname.split('/');
      return path[1];
    }
  }
}
</script>

<style scoped>

</style>
